import Reveal from "@/components/base/Reveal";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-background-100 pb-16 pt-4 md:pb-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <div className="grid grid-cols-1 gap-8 rounded-lg border border-accent-200 bg-gradient-to-br from-accent-100 to-background-100 p-6 md:p-10 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-background-50/70 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-notification-3-line" />
                订阅速报
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px]">
                每期盘点整理好，第一时间发给你
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                我们会把新增的事件、后续进展与澄清说明汇总成一封简短的邮件，控制在三分钟能读完的长度，不做标题党，也不发广告。
              </p>
            </div>
            <div className="lg:col-span-7">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <SubscribeForm />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}